module.exports = __webpack_public_path__ + "img/prev.325e9ac0.png";